import { render, staticRenderFns } from "./TemplateCreateEdit.vue?vue&type=template&id=b781bba6&"
import script from "./TemplateCreateEdit.vue?vue&type=script&lang=js&"
export * from "./TemplateCreateEdit.vue?vue&type=script&lang=js&"
import style0 from "./TemplateCreateEdit.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports